export default __webpack_public_path__ + "static/media/notebook.cb08094b.jpg";